import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import cn from 'classnames'
import pathOr from 'ramda/src/pathOr'
import {
  PRICE_HIGH,
  PRICE_LOW,
  PRICE_MIDDLE,
  priceFieldName,
} from '../constants'
import { BUTTON_OFF, BUTTON_ON } from '../../../../constants'
import { pushFiltersCheckboxes } from '../../../../../../helpers/gtm'
import './price-range.scss'


class PriceRange extends PureComponent {
  state = {
    prices: {
      [PRICE_LOW]: {
        label: this.props.titles.lowPrice,
        value: BUTTON_OFF,
      },
      [PRICE_MIDDLE]: {
        label: this.props.titles.middlePrice,
        value: BUTTON_OFF,
      },
      [PRICE_HIGH]: {
        label: this.props.titles.highPrice,
        value: BUTTON_OFF,
      },
    },
  }

  componentWillMount() {
    this.initPrices()
  }

  componentWillReceiveProps = next => {
    const { prices } = this.props
    if (prices !== next.prices) {
      this.initPrices(next.prices)
    }
  }

  initPrices = (pricesParam) => {
    let prices = pricesParam
    if (prices === undefined) {
      prices = this.props.prices
    }
    this.setState({
      prices: {
        ...this.state.prices,
        [PRICE_LOW]: {
          ...this.state.prices[PRICE_LOW],
          value: pathOr(BUTTON_OFF, [PRICE_LOW])(prices),
        },
        [PRICE_MIDDLE]: {
          ...this.state.prices[PRICE_MIDDLE],
          value: pathOr(BUTTON_OFF, [PRICE_MIDDLE])(prices),
        },
        [PRICE_HIGH]: {
          ...this.state.prices[PRICE_HIGH],
          value: pathOr(BUTTON_OFF, [PRICE_HIGH])(prices),
        },
      },
    })
  }

  onChangeHandler = (...args) => {
    const checked = args[1]
    const fieldName = args[3]
    const { onPriceChange } = this.props
    const value = checked ? BUTTON_ON : BUTTON_OFF
    const [, id] = fieldName.split('_')
    this.setState({
      prices: {
        ...this.state.prices,
        [id]: {
          ...this.state.prices[id],
          value,
        },
      },
    })
    onPriceChange(fieldName, value)
    pushFiltersCheckboxes(fieldName)
  }

  isChecked = value => value === BUTTON_ON

  checkBoxId = id => `price-checkbox-${id}`

  render() {
    const { prices } = this.state
    return (
      <div className="price-range">
        {Object.entries(prices).map((field, key) => (
            <div
              key={key}
              className={cn('price-range__item', this.isChecked(field[1].value) && 'checked')}
            >
              <Field
                id={this.checkBoxId(key)}
                name={priceFieldName(field[0])}
                type="checkbox"
                component="input"
                onChange={this.onChangeHandler}
                checked={this.isChecked(field[1].value)}
              />
              <label
                htmlFor={this.checkBoxId(key)}
              >
                {field[1].label}
              </label>
            </div>
          ),
        )}
      </div>
    )
  }
}


PriceRange.propTypes = {
  titles: PropTypes.shape({
    title: PropTypes.string,
    lowPrice: PropTypes.string,
    middlePrice: PropTypes.string,
    highPrice: PropTypes.string,
  }),
  prices: PropTypes.objectOf(PropTypes.string),
  onPriceChange: PropTypes.func.isRequired,
}

export default PriceRange
